module.exports = __webpack_public_path__ + "img/shouye-gongzhonghao.9b8ceac5.jpg";